// Substituídas por "Conferir Movimentações" e "Exportar Movimentação"; ninguém executa por elas desde 06/07/2026.
export const DEPRECATED_TEMPLATES = ["Conferir Movimentação", "Exportar Movimentações"];

export interface IActivity {
  id: string;
  templateActivityId: string;
  name: string;
  type: string;
  tables: {
    templateAcivityTableId: string;
    snowflakeTableId: string;
    name: string;
    type: string;
  }[];
  connectors: {
    templateActivityConnectorId: string;
    connectorId: string;
    name: string;
    type: string;
  }[];
  params: {
    scheduling?: string;
    isAutomatic?: string;
    layoutId?: string;
    editableFields?: string[]; // Array de IDs dos campos editáveis selecionados
    beneficiaryFields?: { // Campos do beneficiário PJ para "Campanhas"
      key: string;
      label: string;
      visible: boolean;
      mandatory: boolean;
    }[];
    cltFields?: { // Campos do beneficiário CLT para "Campanhas"
      key: string;
      label: string;
      visible: boolean;
      mandatory: boolean;
    }[];
  };
}

export interface ITemplate {
  id: string;
  name: string;
  /** Essa propriedade define se template já foi configurado ou não para mostrar no front */
  /** Ao editar, se há vinculo entre template e workspace, apenas retorna true */
  isConfigured: boolean;
  activities: IActivity[];
}

export interface ICategory {
  name: string;
  shortName: string;
  templates: ITemplate[];
}

export interface IWorkspace {
  workspaceId: string;
}
